// extracted by mini-css-extract-plugin
module.exports = {"highlight-stats":"styles_highlight-stats__3d9bK","stat-item":"styles_stat-item___NZc5","stat-title":"styles_stat-title__bdyph"};